export default __webpack_public_path__ + "static/media/student.1b436de4.svg";